<template>
  <v-app id="inspire">
    <AlertCoverNotLandScape/>
    <div class="front">
      <header>
        <div class="fiexdRegion">
          <!--▼▼ハンバーガーメニューここから▼▼-->
          <div id="nav-drawer">
            <input id="nav-input" type="checkbox" class="nav-unshown">
            <label id="nav-open" for="nav-input"><span></span></label>
            <label class="nav-unshown" id="nav-close" for="nav-input"></label>
            <div id="nav-content">
              <nav class="fixedNav-mobile">
                <ul>
                  <li><a href="#"><img src="/static/front/min-logo.png"></a></li>
                  <li><a href="#concept">concept</a></li>
                  <li><a href="#service">easy to use</a></li>
                  <li><a href="/artist">artist</a></li>
                  <li><a href="#news">news</a></li>
                  <li><a href="javascript:;" @click.stop="terms = true">policy</a></li>
                  <li><a href="/login" target="_blank"><img src="/static/front/login.png"></a></li>
                </ul>
              </nav>
            </div>
          </div>
          <p class="logo-mobile"><a href="/login" target="_blank"><img src="/static/front/login.png"></a></p>
          <!--▲▲ハンバーガーメニューここまで▲▲-->
        </div>

        <div class="mainVisual">
          <h1 class="has-text-centered"><img src="/static/front/logo.png" alt="ウィズム"></h1>
          <p class="has-text-white has-text-centered font-bd">
            ウエディングを主とした音楽のプロデュースを行っております。
          </p>
          <p class="has-text-white has-text-centered font-bd">
            音楽を「楽しく、安心、かんたん」に、ご利用いただけるサービスをご提供致します。
          </p>
          <p>
            <a class="v2-service-link" href="https://v2.withm.net/service" target="_blank">ご試聴はこちら</a>
          </p>
          <p class="log topLoginHome"><a href="/login" target="_blank"><img src="/static/front/login.png"></a></p>
        </div>
        <nav class="fixedNav">
          <ul>
            <li><a href="/"><img src="/static/front/min-logo.png"></a></li>
            <li><a href="#concept">concept</a></li>
            <li><a href="#service">easy to use</a></li>
            <li><a href="/artist">artist</a></li>
            <li><a href="#news">news</a></li>
            <li><a href="#contact">contact</a></li>
            <li><a href="javascript:;" @click.stop="terms = true">policy</a></li>
            <li><a href="/login" target="_blank"><img src="/static/front/login.png"></a></li>
          </ul>
        </nav>
      </header>

      <section id="concept">
        <h2>CONCEPT</h2>
        <img src="/static/front/concept.png" alt="">
        <!--<v-parallax src="/static/front/concept.jpg" class="text-xs-center parallax-front">
          <h3>with＋mとは、音楽を通じて「繋げる」サービスです。<br>核となるのは３つのM。</h3>
        </v-parallax>-->
        <div class="flex-centerHome">
          <dl class="concept_dl">
            <dt>
              <span class="concept_dt-color1">M</span>arriage<br>
              <span class="concept_span border-gr">結婚</span>
            </dt>
            <dd>
              想いを伝える<br>
              「一生に一度の時間」を繋げます。
            </dd>
            <dd>
              音楽は、結婚式を彩る重要なアイテムです。 音楽を選択することによって得られる空間効果や表情、生まれる会話の数々はとてもかけがえのないものです。
              普段はなかなか口にする事が出来ない感謝の想いを、そっと後押ししてくれるような音楽をご提案致します。
              音楽を通じて駆け上る想いが、大切な方々を結びつけます。
            </dd>
          </dl>

          <dl class="concept_dl">
            <dt>
              <span class="concept_dt-color2">M</span>essage<br>
              <span class="concept_span border-pi">想い</span>
            </dt>
            <dd>
              音楽に込めた<br>
              「メッセージ」を繋げます。
            </dd>
            <dd>
              創り手の想いと受け手の想いを引き合わせ、ふたつの想いを繋げます。
              そしてアーティストが歌詞に込めた言葉のパワーを通じて新郎新婦様のメッセージをより一層、列席者さまの心へ響かせる空間を創り上げます。
            </dd>
          </dl>

          <dl class="concept_dl">
            <dt>
              <span class="concept_dt-color3">M</span>emory<br>
              <span class="concept_span border-ye">思い出</span>
            </dt>
            <dd>
              忘れられない、<br>
              大切な「記憶」へと繋げます。
            </dd>
            <dd>
              with+mがご提供する多彩なジャンルの音楽は、全曲完全ロイヤリティフリーです。
              音楽を差し替える必要はなく、拍手や歓声といった臨場感をそのままに残せます。
              その時に感じた歓声や祝福の言葉は色褪せる事なく、何十年経っても、ありのままに思い返す事が出来ます。
            </dd>
          </dl>
        </div>
      </section>

      <section id="service">
        <h2>Easy To Use</h2>
        <div class="flex-space-around">
          <p><img src="/static/front/pc-sp.png"></p>
          <ul>
            <li>
              <dl>
                <dt>
                  <span>STEP1</span>
                  <span class="is-size-5 is-size-6-mobile">ログイン機能</span>
                </dt>
                <dd>
                  新郎新婦はwith+m締結会場より発行されたIDにてログインする事により、当サービスをご活用できます。
                </dd>
              </dl>
            </li>
            <li>
              <dl>
                <dt>
                  <span>STEP2</span>
                  <span class="is-size-5 is-size-6-mobile">音楽リスト作成</span></dt>
                <dd>
                  専用インターフェースを使用し、新郎新婦ご自身でお好きな時間に、結婚式の音楽リストを作成できます。<br>
                  これにより音響打ち合わせをスムーズにし、CD原盤をご準備する必要もございません。
                </dd>
              </dl>
            </li>
            <li>
              <dl>
                <dt>
                  <span>STEP3</span>
                  <span class="is-size-5 is-size-6-mobile">締結会場にて音楽をダウンロード</span>
                </dt>
                <dd>
                  お好みの音楽を選択した後、締結会場は専用ページにて音楽をダウンロード、オペレーション準備をする事が可能となります。
                </dd>
              </dl>
            </li>
          </ul>
        </div>
      </section>

      <section id="artistHome">
        <h2>ARTIST</h2>
        <h3 class="is-size-2 is-size-5-mobile has-text-centered">随時追加される、<br>バラエティ豊かなラインナップ</h3>
        <p class="artist-sub-title">
          各種メディアに取り上げられた実績のあるアーティストたちを擁し、<br>
          およそ1300曲に及ぶ、クオリティの高い楽曲をご提供いたします。
        </p>
        <!--<p class="has-text-centered"><img src="/static/front/visual.png"></p>-->

        <!--cssループスライダーここから-->
        <div class="sliderBox">
          <ul>
            <li><img src="/static/front/artist1.png"></li>
            <li><img src="/static/front/artist2.png"></li>
            <li><img src="/static/front/artist3.png"></li>
            <li><img src="/static/front/artist4.png"></li>
            <li><img src="/static/front/artist5.png"></li>
            <li><img src="/static/front/artist6.png"></li>
            <li><img src="/static/front/artist7.png"></li>
            <li><img src="/static/front/artist8.png"></li>
            <li><img src="/static/front/artist9.png"></li>
            <li><img src="/static/front/artist10.png"></li>
            <li><img src="/static/front/artist11.png"></li>
            <li><img src="/static/front/artist12.png"></li>
            <li><img src="/static/front/artist15.png"></li>
            <li><img src="/static/front/artist16.png"></li>
            <li><img src="/static/front/artist17.png"></li>
            <li><img src="/static/front/artist18.png"></li>
            <li><img src="/static/front/artist19.png"></li>
          </ul>
        </div>
        <!--cssループスライダーここまで-->
        <p class="artist-jump-btn"><a href="/artist">ARTIST LINEUP</a></p>
      </section>

      <section id="news">
        <h2 class="">NEWS</h2>

        <!--1つのニュースここから-->
        <div class="news-content">
          <div class="newsContent-flex">
            <p class="transform90 font-bd">2019.2.4</p>
            <p>
              with＋mサイトを公開しました<br>
              <span class="is-size-7 color-pnik">プレスリリース</span><br>
            </p>
          </div>
          <!-- トリガー -->
          <!--<div class="moreButton"><button onclick="modal_open('hoge1');"><img src="/static/front/memo.png"></button></div>-->
        </div>

        <!-- モーダル ここから-->
        <div class="modalHome" id="hoge1">
          <div class="modal_wall" onclick="modal_close('hoge1');"></div>
          <div class="modal_body">
            <div class="modal_inner">
              <div class="modal_close"><span onclick="modal_close('hoge1');"><img src="/static/front/cross.png"></span></div>
              <div class="modal_content">
                <div class="modal-news-content">
                  <p class="font-bd">2018.06.18</p>
                  <p>
                    ぶんはゴーシュの身動き怒り顔とかっこうでちがいへんだん。またこれからだめますたにおいてゴーシュましまし。
                    残念ましたんたはますそれでは野ねずみの同じたちのときをはやはり勝手たたて、どこでも虎がきれれものましまし。
                    しすぎおれも先生でな…て明方のトランペットの音顔が見第一先生たちの失敗をするば来ますでし。音はいまだしてしまいた。
                    ポケットは一なっトマトのようにいろが来ん。<br>
                    <span class="is-size-7 color-pnik">プレスリリース</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- モーダル ここまで-->
        <!--1つのニュースここまで-->
      </section>

      <section id="contact">
        <h2 class="">CONTACT</h2>
        <p class="contact-text">
          本サービスのご不明点がございましたら下記フォームよりお気軽にお問い合わせください。
        </p>
        <v-card flat>
          <v-form ref="form" @submit.prevent="submit" class="contact-form">
            <v-container grid-list-xl fluid>
              <v-layout wrap>
                <v-flex xs12 sm6>
                  <v-text-field
                    v-model="form.last"
                    :rules="rules.name"
                    color="orange"
                    label="姓"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    v-model="form.first"
                    :rules="rules.name"
                    color="orange"
                    label="名"
                    required
                  ></v-text-field>
                </v-flex>
                <!--
                <v-flex xs12>
                  <v-text-field
                    v-model="form.company"
                    color="teal"
                    label="会社名"
                  ></v-text-field>
                </v-flex>
                -->
                <v-flex xs12>
                  <v-text-field
                    v-model="form.email"
                    :rules="rules.email"
                    color="orange"
                    label="メールアドレス"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="form.tel"
                    color="teal"
                    label="電話番号"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="form.bio"
                    color="teal"
                    multi-line
                  >
                    <div slot="label">
                      お問い合わせ内容
                    </div>
                  </v-text-field>
                </v-flex>
                <v-flex xs12>
                  <p>プライバシーポリシーにご同意ください。</p>
                  <v-checkbox
                    v-model="form.terms"
                    color="green"
                  >
                    <div slot="label">
                      <a href="javascript:;" @click.stop="terms = true">プライバシーポリシー</a>
                    </div>
                  </v-checkbox>
                </v-flex>
              </v-layout>
            </v-container>
            <v-card-actions>
              <v-btn flat @click="resetForm">リセット</v-btn>
              <v-spacer></v-spacer>
              <v-btn
                :disabled="!formIsValid"
                flat
                color="primary"
                type="submit"
              >送信</v-btn>
            </v-card-actions>
          </v-form>
          <v-dialog v-model="terms" width="600px">
            <v-card>
              <v-card-title class="title" style="padding:20px;">プライバシーポリシー</v-card-title>
              <v-card-text style="padding:20px;">
                <policy-body/>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  flat
                  color="purple"
                  @click="terms = false"
                >Ok</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card>
      </section>

      <footer>
        <div class="footer-flex">
          <!--
          <ul class="inline">
            <li><a href="#">プライバシーポリシー</a>&nbsp;&nbsp;&nbsp;｜</li>
            <li>&nbsp;&nbsp;&nbsp;<a href="http://fiveinnovation.jp/">運営会社</a>&nbsp;&nbsp;&nbsp;｜</li>
            <li>&nbsp;&nbsp;&nbsp;<a href="#contact">お問い合わせ</a></li>
          </ul>
          -->
          <p class="footerLogo"><img src="/static/front/min-logo.png"></p>
        </div>
        <p class="has-text-centered"><small>©2018 ファイブイノベーション株式会社</small></p>
      </footer>
    </div>
  </v-app>
</template>

<script>
import ContactService from '@/components/services/ContactService.vue'
import PolicyBody from '@/components/PolicyBody.vue'
import AlertCoverNotLandScape from '@/components/atoms/AlertCoverNotLandScape'
export default {
  name: 'Front',
  components: {
    AlertCoverNotLandScape,
    PolicyBody
  },
  data () {
    const defaultForm = Object.freeze({
      first: '',
      last: '',
      company: '',
      email: '',
      tel: '',
      bio: '',
      terms: false
    })

    return {
      form: Object.assign({}, defaultForm),
      rules: {
        name: [val => (val || '').length > 0 || 'この項目は必須です。'],
        email: [val => (val || '').length > 0 || 'この項目は必須です。']
      },
      sendContact: false,
      terms: false,
      defaultForm
    }
  },

  beforeCreate () {
    let userAgent = window.navigator.userAgent.toLowerCase()
    if (userAgent.indexOf('trident') !== -1) {
      location.href = '/msie'
    }
  },

  computed: {
    formIsValid () {
      return (
        this.form.first &&
        this.form.last &&
        this.form.email &&
        this.form.terms
      )
    }
  },

  methods: {
    checkBrowser () {
      let userAgent = window.navigator.userAgent
      console.log(userAgent)
    },
    resetForm () {
      this.form = Object.assign({}, this.defaultForm)
      this.$refs.form.reset()
    },
    submit () {
      this.sendContact = true
      ContactService.postContact(this.form.last, this.form.first, this.form.email, this.form.bio, this.form.tel, (response) => {
        // お問い合わせ成功
        alert('お問い合わせを送信しました。')
        console.log(response)
      }, (error) => {
        // お問い合わせ失敗
        alert('お問い合わせの送信に失敗しました。')
        console.error(error)
      })
      this.resetForm()
    }
  }
}
</script>

<style scoped>
@import "../assets/style/front.scss";
.parallax-front {
  height: 350px!important;
}
.parallax-front h3 {
  font-size: 2.5rem;
}

@media screen and (max-width:959px){
  .parallax-front {
  height: 300px!important;
}
.parallax-front h3 {
  font-size: 2.0rem;
  }
}

@media screen and (max-width:768px){
  .parallax-front {
    height: 200px!important;
  }
  .parallax-front h3 {
    font-size: 1.5rem;
  }
}

.v2-service-link {
    background-color: #f382ae;
    border-radius: 10px;
    height: 40px;
    width: 80px;
    margin: 15px auto;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 10px;
    font-weight: bold;
    color: #ffffff;
  }
  .v2-service-link:hover {
    box-shadow: 0 0 20px 0;
    transition: all 0.7s 0s ease;
  }
  @media screen and (min-width: 600px) and (max-width: 959px) {
    .v2-service-link {
      height: 60px;
      width: 150px;
      margin: 20px auto;
      font-size: 13px;
    }
  }
  @media screen and (min-width: 960px) {
    .v2-service-link {
      border-radius: 15px;
      height: 80px;
      width: 200px;
      font-size: 18px;
      margin: 40px auto 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Front.vue